export const ProductResource = [
  {
    name: 'product',
    list: 'products',
  },
  {
    name: 'custom-categories',
    list: '/products/custom-categories',
  },
  {
    name: 'quality-requirements/templates',
    description: 'Product quality requirements templates',
  },
  {
    name: 'products-quality-requirements-apply-template',
    create: 'products/:id/quality-requirements/apply-template',
  },
];
